import React, { useEffect } from 'react';
import { Check } from 'lucide-react';
import '../styles/ScheduleConsult.css';

const AUTO_REDIRECT_MS = 8000;

/**
 * Full-page success state after form submission. Auto-redirects to home after a few seconds.
 */
function SubmitSuccessSplash({
  lead,
  details = [],
  note,
  onGoHome,
  buttonLabel = 'Return to home',
}) {
  useEffect(() => {
    const timer = setTimeout(onGoHome, AUTO_REDIRECT_MS);
    return () => clearTimeout(timer);
  }, [onGoHome]);

  return (
    <div className="schedule-success-splash" role="status" aria-live="polite">
      <div className="schedule-success-card">
        <div className="schedule-success-icon" aria-hidden="true">
          <Check size={40} strokeWidth={2} />
        </div>
        <h2>You&apos;re all set!</h2>
        <p className="schedule-success-lead">{lead}</p>
        {details.length > 0 && (
          <div className="schedule-success-details">
            {details.map((item) => (
              <div key={item.label} className="schedule-success-detail">
                <span className="schedule-success-detail-label">{item.label}</span>
                <span className="schedule-success-detail-value">{item.value}</span>
              </div>
            ))}
          </div>
        )}
        {note && <p className="schedule-success-note">{note}</p>}
        <button type="button" className="schedule-success-btn" onClick={onGoHome}>
          {buttonLabel}
        </button>
        <p className="schedule-success-redirect-hint">
          Redirecting to home in a few seconds…
        </p>
      </div>
    </div>
  );
}

export default SubmitSuccessSplash;
